import { definePreset, } from '@unocss/core';
import presetWind3 from '@unocss/preset-wind3';
import { theme as wind3Theme } from '@unocss/preset-wind3/theme';
export const textShortcuts = {
    'title-36-h54-b': 'font-bold text-36px leading-54px tracking-1px',
    'title-36-h54-r': 'font-regular text-36px leading-54px tracking-1px',
    'title-24-h24-b': 'font-bold text-24px leading-24px tracking-1px',
    'title-24-h36-r': 'font-regular text-24px leading-36px tracking-1px',
    'title-20-h24-m': 'font-medium text-20px leading-24px tracking-1px',
    'title-18-h18-b': 'font-bold text-18px leading-18px tracking-1px',
    'title-14-h24-b': 'font-bold text-14px leading-24px tracking-1px',
    'title-14-h20-b': 'font-bold text-14px leading-20px tracking-1px',
    'title-14-h16-m': 'font-medium text-14px leading-16px tracking-1px',
    'title-12-h24-m': 'font-medium text-12px leading-24px tracking-1px',
    'title-12-h16-b': 'font-bold text-12px leading-16px tracking-1px',
    'title-12-h16-m': 'font-medium text-12px leading-16px tracking-1px',
    'content-20-h24-r': 'font-regular text-20px leading-24px tracking-1px',
    'content-16-h24-r': 'font-regular text-16px leading-24px tracking-1px',
    'content-14-h24-r': 'font-regular text-14px leading-24px tracking-1px',
    'content-12-h24-r': 'font-regular text-12px leading-24px tracking-1px',
    'content-12-h16-b': 'font-bold text-12px leading-16px tracking-1px',
    'content-12-h16-r': 'font-regular text-12px leading-16px tracking-1px',
    'content-11-h20-r': 'font-regular text-11px leading-20px tracking-1px',
    'content-11-h16-r': 'font-regular text-11px leading-16px tracking-1px',
    'content-10-h16-b': 'font-bold text-10px leading-16px tracking-1px',
    'content-10-h12-r': 'font-regular text-10px leading-12px tracking-1px',
    'lnk-18-h18-b': 'font-bold text-18px leading-18px tracking-1px underline',
    'lnk-14-h24-b': 'font-bold text-14px leading-24px tracking-1px underline',
    'lnk-14-h24-r': 'font-regular text-14px leading-24px tracking-1px underline',
    'lnk-12-h16-r': 'font-regular text-12px leading-16px tracking-1px underline',
    'lnk-11-h16-r': 'font-regular text-11px leading-16px tracking-1px underline',
    'lnk-10-h12-r': 'font-regular text-10px leading-12px tracking-1px underline',
};
export const shortcuts = {
    ...textShortcuts,
    'scrollbar-hide': 'scrollbar-width-none scrollbar:hidden',
    'scrollbar-default': 'scrollbar-width-auto scrollbar:block',
};
export const colors = {
    primary: {
        '100': '#3C4238',
        '90': '#4C5347',
        '80': '#5F6858',
        '70': '#727C69',
        '60': '#86927C',
        '50': '#9CA694',
        '40': '#B3BAAC',
        '30': '#CBD0C7',
        '20': '#E2E5E0',
        '10': '#F3F4F2',
    },
    brand: {
        yellow: '#FFEF00',
        yellowBorder: '#F5E50C',
        deepYellow: '#F8D000',
        blushPink: '#FF9A93',
        grayPurpleTint: '#869EAD',
        grayPurple: '#7A7A7A',
    },
    green: '#24B253',
    orange: '#FF8514',
    red: '#DD4F4E',
    blue: '#3B63B5',
    brown: '#9F7524',
    lightPink: '#FDF4EF',
    deepBrown: '#845433',
    frameOrange: '#F89500',
    lightGreen: '#5FCAB6',
    white: '#FFFFFF',
    lightGray: '#F9F8F9',
    bgGray: '#F2F2F2',
    blackTransparent: 'rgba(0, 0, 0, 0.12)',
    'green-transparent-10': 'rgba(60, 66, 56, 0.1)',
    'green-transparent-30': 'rgba(60, 66, 56, 0.3)',
    'green-60-5': 'rgba(134, 146, 124, 0.05)',
    'transparent-70': 'rgba(43,43,43,0.7)',
};
export const theme = {
    ...wind3Theme,
    fontWeight: {
        ...wind3Theme.fontWeight,
        regular: '400',
    },
    colors: {
        ...wind3Theme.colors,
        ...colors,
    },
    boxShadow: {
        ...wind3Theme.boxShadow,
        logo: '0px 4px 4px 0px rgba(0, 0, 0, 0.20)',
        'dropdown-dialog': '0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
        'btn-card': '0px 0px 3px 0px rgba(60, 66, 56, 0.16)',
        'function-panel': '0px -1px 3px 0px rgba(60, 66, 56, 0.15)',
        'top-fix': '0px 2px 5px 0px rgba(0, 0, 0, 0.04)',
        'bottom-fix': '0px -1px 3px 0px rgba(60, 66, 56, 0.10)',
        inner: '0px 0px 2px 0px rgba(0, 0, 0, 0.10) inset',
        calendar: '0px 2px 10px rgba(0, 0, 0, 0.1)',
        btn: '0px 0px 3px 0px #3C423829',
    },
};
const preflights = [
    {
        getCSS: () => `
      a { color: ${colors.blue} }
      a:visited { color: #27009e }
      a:active { color: #1f539d }
    `,
    },
];
const rules = [
    [/^scrollbar-width-(auto|none)/, ([_, prop]) => ({ 'scrollbar-width': prop })],
];
const preset = definePreset((options) => {
    const uno = presetWind3(options);
    return {
        ...uno,
        name: '@evolutivelabs/unocss-preset-amuse',
        shortcuts: { ...uno.shortcuts, ...shortcuts },
        theme,
        preflights: [...(uno.preflights ?? []), ...preflights],
        variants: [
            ...(uno.variants ?? []),
            (matcher) => matcher.startsWith('scrollbar:')
                ? {
                    matcher: matcher.slice(10),
                    selector: (s) => `${s}::-webkit-scrollbar`,
                }
                : matcher,
        ],
        rules: [...(uno.rules ?? []), ...rules],
    };
});
export default preset;
